import { TemplateRef, Directive } from '@angular/core';

@Directive({
  selector: 'ng-template[palantirTabLazyLoadedContent]',
  standalone: false,
})
export class PalantirTabContentDirective {
  public constructor(public _template: TemplateRef<any>) {}
}
